/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AccesMtBody } from '../model/accesMtBody';
// @ts-ignore
import { BodyContentTypeCode } from '../model/bodyContentTypeCode';
// @ts-ignore
import { CodeInteroperabiliteKey } from '../model/codeInteroperabiliteKey';
// @ts-ignore
import { DMPStatut } from '../model/dMPStatut';
// @ts-ignore
import { DocumentAEnvoyer } from '../model/documentAEnvoyer';
// @ts-ignore
import { DocumentEnvoye } from '../model/documentEnvoye';
// @ts-ignore
import { DocumentTelecharge } from '../model/documentTelecharge';
// @ts-ignore
import { ErrorSessionCPX } from '../model/errorSessionCPX';
// @ts-ignore
import { ParametresRechercheDocuments } from '../model/parametresRechercheDocuments';
// @ts-ignore
import { PatientInfos } from '../model/patientInfos';
// @ts-ignore
import { ResultatRechercheDocumentsInner } from '../model/resultatRechercheDocumentsInner';
// @ts-ignore
import { TransactionAccesBody } from '../model/transactionAccesBody';
// @ts-ignore
import { TransactionDocumentBody } from '../model/transactionDocumentBody';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class DMPService {

    protected basePath = 'https://virtserver.swaggerhub.com/dinno9/Compagnon-CPS_DMP/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Ajout d\&#39;un document au DMP du patient
     * Cette route prend en charge les transactions TD.2.1 et TD2.2. La différenciation entre carte CPS et CPE se fait au sein du service CompagnonCPS
     * @param ins INS du patient dont on veut connaître le statut du DMP
     * @param uniqueId Identifiant unique du documnent
     * @param uuid Identifiant unique de la version du document
     * @param documentAEnvoyer 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addDocument(ins: string, uniqueId?: string, uuid?: string, documentAEnvoyer?: DocumentAEnvoyer, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<DocumentEnvoye>;
    public addDocument(ins: string, uniqueId?: string, uuid?: string, documentAEnvoyer?: DocumentAEnvoyer, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<DocumentEnvoye>>;
    public addDocument(ins: string, uniqueId?: string, uuid?: string, documentAEnvoyer?: DocumentAEnvoyer, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<DocumentEnvoye>>;
    public addDocument(ins: string, uniqueId?: string, uuid?: string, documentAEnvoyer?: DocumentAEnvoyer, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling addDocument.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }
        if (uniqueId !== undefined && uniqueId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>uniqueId, 'uniqueId');
        }
        if (uuid !== undefined && uuid !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>uuid, 'uuid');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/document`;
        return this.httpClient.request<DocumentEnvoye>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                body: documentAEnvoyer,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Archive ou désarchive un document
     * Archive un document s\&#39;il n\&#39;est pas archivé et désarchive un document s\&#39;il est archivé (TD3.3d)
     * @param ins INS du patient dont on veut connaître le statut du DMP
     * @param uniqueId 
     * @param bodyContentTypeCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public archiveDocument(ins: string, uniqueId: string, bodyContentTypeCode?: BodyContentTypeCode, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<any>;
    public archiveDocument(ins: string, uniqueId: string, bodyContentTypeCode?: BodyContentTypeCode, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<any>>;
    public archiveDocument(ins: string, uniqueId: string, bodyContentTypeCode?: BodyContentTypeCode, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<any>>;
    public archiveDocument(ins: string, uniqueId: string, bodyContentTypeCode?: BodyContentTypeCode, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling archiveDocument.');
        }
        if (uniqueId === null || uniqueId === undefined) {
            throw new Error('Required parameter uniqueId was null or undefined when calling archiveDocument.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }
        if (uniqueId !== undefined && uniqueId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>uniqueId, 'uniqueId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/document/archiver`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                body: bodyContentTypeCode,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer un document
     * Supprimer un document (TD3.3c)
     * @param ins INS du patient dont on veut connaître le statut du DMP
     * @param uniqueId 
     * @param uuid 
     * @param contentTypeCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDocument(ins: string, uniqueId: string, uuid?: string, contentTypeCode?: BodyContentTypeCode, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<any>;
    public deleteDocument(ins: string, uniqueId: string, uuid?: string, contentTypeCode?: BodyContentTypeCode, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<any>>;
    public deleteDocument(ins: string, uniqueId: string, uuid?: string, contentTypeCode?: BodyContentTypeCode, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<any>>;
    public deleteDocument(ins: string, uniqueId: string, uuid?: string, contentTypeCode?: BodyContentTypeCode, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling deleteDocument.');
        }
        if (uniqueId === null || uniqueId === undefined) {
            throw new Error('Required parameter uniqueId was null or undefined when calling deleteDocument.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }
        if (uniqueId !== undefined && uniqueId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>uniqueId, 'uniqueId');
        }
        if (uuid !== undefined && uuid !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>uuid, 'uuid');
        }
        if (contentTypeCode !== undefined && contentTypeCode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>contentTypeCode, 'contentTypeCode');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/document`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Télécharger un document
     * Télécharger un document (TD3.2)
     * @param ins INS du patient dont on veut connaître le statut du DMP
     * @param uniqueId 
     * @param avecCdaHeaders Si true, renvoi les headers CDA
     * @param avecCdaContent Si true, renvoi le content CDA
     * @param avecCreateur Si true, renvoi les données sur l\&#39;utilisateur ayant déposé le document
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadDocument(ins: string, uniqueId: string, avecCdaHeaders: boolean, avecCdaContent: boolean, avecCreateur: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<DocumentTelecharge>;
    public downloadDocument(ins: string, uniqueId: string, avecCdaHeaders: boolean, avecCdaContent: boolean, avecCreateur: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<DocumentTelecharge>>;
    public downloadDocument(ins: string, uniqueId: string, avecCdaHeaders: boolean, avecCdaContent: boolean, avecCreateur: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<DocumentTelecharge>>;
    public downloadDocument(ins: string, uniqueId: string, avecCdaHeaders: boolean, avecCdaContent: boolean, avecCreateur: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling downloadDocument.');
        }
        if (uniqueId === null || uniqueId === undefined) {
            throw new Error('Required parameter uniqueId was null or undefined when calling downloadDocument.');
        }
        if (avecCdaHeaders === null || avecCdaHeaders === undefined) {
            throw new Error('Required parameter avecCdaHeaders was null or undefined when calling downloadDocument.');
        }
        if (avecCdaContent === null || avecCdaContent === undefined) {
            throw new Error('Required parameter avecCdaContent was null or undefined when calling downloadDocument.');
        }
        if (avecCreateur === null || avecCreateur === undefined) {
            throw new Error('Required parameter avecCreateur was null or undefined when calling downloadDocument.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }
        if (uniqueId !== undefined && uniqueId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>uniqueId, 'uniqueId');
        }
        if (avecCdaHeaders !== undefined && avecCdaHeaders !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>avecCdaHeaders, 'avecCdaHeaders');
        }
        if (avecCdaContent !== undefined && avecCdaContent !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>avecCdaContent, 'avecCdaContent');
        }
        if (avecCreateur !== undefined && avecCreateur !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>avecCreateur, 'avecCreateur');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/document`;
        return this.httpClient.request<DocumentTelecharge>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Recherche de documents pour un patient
     * Recherche de documents pour un patient (TD3.1)
     * @param ins INS du patient dont on veut connaître le statut du DMP
     * @param parametresRechercheDocuments 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findDocuments(ins: string, parametresRechercheDocuments?: ParametresRechercheDocuments, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<Array<Array<ResultatRechercheDocumentsInner>>>;
    public findDocuments(ins: string, parametresRechercheDocuments?: ParametresRechercheDocuments, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<Array<Array<ResultatRechercheDocumentsInner>>>>;
    public findDocuments(ins: string, parametresRechercheDocuments?: ParametresRechercheDocuments, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<Array<Array<ResultatRechercheDocumentsInner>>>>;
    public findDocuments(ins: string, parametresRechercheDocuments?: ParametresRechercheDocuments, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling findDocuments.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/document/recherche`;
        return this.httpClient.request<Array<Array<ResultatRechercheDocumentsInner>>>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                body: parametresRechercheDocuments,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupère les codes d\&#39;interopérabilité liés au DMP
     * @param codes 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCodesInteroperabilite(codes?: Array<'DOCUMENT_TYPE_CODE' | 'STRUCTURE_CADRE_EXERCICE' | 'PS_PROFESSION' | 'PS_SPECIALITE' | 'DOCUMENT_FORMAT_CODE' | 'DOCUMENT_CONFIDENTIALITY' | 'CONTENT_TYPE_CODE' | 'DOCUMENT_CLASS_CODE' | 'STRUCTURE_ACTIVITE'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<CodeInteroperabiliteKey>;
    public getCodesInteroperabilite(codes?: Array<'DOCUMENT_TYPE_CODE' | 'STRUCTURE_CADRE_EXERCICE' | 'PS_PROFESSION' | 'PS_SPECIALITE' | 'DOCUMENT_FORMAT_CODE' | 'DOCUMENT_CONFIDENTIALITY' | 'CONTENT_TYPE_CODE' | 'DOCUMENT_CLASS_CODE' | 'STRUCTURE_ACTIVITE'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<CodeInteroperabiliteKey>>;
    public getCodesInteroperabilite(codes?: Array<'DOCUMENT_TYPE_CODE' | 'STRUCTURE_CADRE_EXERCICE' | 'PS_PROFESSION' | 'PS_SPECIALITE' | 'DOCUMENT_FORMAT_CODE' | 'DOCUMENT_CONFIDENTIALITY' | 'CONTENT_TYPE_CODE' | 'DOCUMENT_CLASS_CODE' | 'STRUCTURE_ACTIVITE'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<CodeInteroperabiliteKey>>;
    public getCodesInteroperabilite(codes?: Array<'DOCUMENT_TYPE_CODE' | 'STRUCTURE_CADRE_EXERCICE' | 'PS_PROFESSION' | 'PS_SPECIALITE' | 'DOCUMENT_FORMAT_CODE' | 'DOCUMENT_CONFIDENTIALITY' | 'CONTENT_TYPE_CODE' | 'DOCUMENT_CLASS_CODE' | 'STRUCTURE_ACTIVITE'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (codes) {
            codes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'codes');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/codesInteroperabilite`;
        return this.httpClient.request<CodeInteroperabiliteKey>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupère le statut d\&#39;un DMP
     * Récupère le statut du DMP d\&#39;un patient en utilisant l\&#39;INS du patient passé en query (TD0.2)
     * @param ins INS du patient dont on veut connaître le statut du DMP
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDMPStatus(ins: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<DMPStatut>;
    public getDMPStatus(ins: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<DMPStatut>>;
    public getDMPStatus(ins: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<DMPStatut>>;
    public getDMPStatus(ins: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling getDMPStatus.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/statut`;
        return this.httpClient.request<DMPStatut>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupère une liste d\&#39;URLs liées au DMP du patient
     * Récupère une liste d\&#39;URLs liées au DMP du patient (TD0.9)
     * @param ins INS du patient dont on veut connaître le statut du DMP
     * @param oid OID du patient dont on veut connaître le statut du DMP
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDMPWebPSUrls(ins: string, oid: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<Array<string>>;
    public getDMPWebPSUrls(ins: string, oid: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<Array<string>>>;
    public getDMPWebPSUrls(ins: string, oid: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<Array<string>>>;
    public getDMPWebPSUrls(ins: string, oid: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling getDMPWebPSUrls.');
        }
        if (oid === null || oid === undefined) {
            throw new Error('Required parameter oid was null or undefined when calling getDMPWebPSUrls.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }
        if (oid !== undefined && oid !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>oid, 'oid');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/web-ps-urls`;
        return this.httpClient.request<Array<string>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Renvoi les informations sur le patient lié à l\&#39;INS passé en paramètre
     * @param ins INS du patient dont on récupérer les informations
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPatientInfos(ins: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<PatientInfos>;
    public getPatientInfos(ins: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<PatientInfos>>;
    public getPatientInfos(ins: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<PatientInfos>>;
    public getPatientInfos(ins: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling getPatientInfos.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/patientInfos`;
        return this.httpClient.request<PatientInfos>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifie les accès à un DMP
     * Modifier les droits d\&#39;accès au DMP d\&#39;un patient (TD0.3a et TD0.3b)
     * @param ins INS du patient dont on veut connaître le statut du DMP
     * @param transactionAccesBody Autorisation d\&#39;accès au DMP et raison si bris de glace
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDMPAcces(ins: string, transactionAccesBody?: TransactionAccesBody, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<any>;
    public updateDMPAcces(ins: string, transactionAccesBody?: TransactionAccesBody, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<any>>;
    public updateDMPAcces(ins: string, transactionAccesBody?: TransactionAccesBody, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<any>>;
    public updateDMPAcces(ins: string, transactionAccesBody?: TransactionAccesBody, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling updateDMPAcces.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/acces`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                body: transactionAccesBody,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifie l\&#39;état MT de l\&#39;utilisateur
     * Attribuer ou retirer le statut de Médecin Traitant (TD0.3c)
     * @param ins INS du patient dont on veut connaître le statut du DMP
     * @param accesMtBody 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDMPMedecinTraitant(ins: string, accesMtBody?: AccesMtBody, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<any>;
    public updateDMPMedecinTraitant(ins: string, accesMtBody?: AccesMtBody, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<any>>;
    public updateDMPMedecinTraitant(ins: string, accesMtBody?: AccesMtBody, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<any>>;
    public updateDMPMedecinTraitant(ins: string, accesMtBody?: AccesMtBody, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling updateDMPMedecinTraitant.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/acces/mt`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                body: accesMtBody,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier les données d\&#39;un document
     * Modification d\&#39;informations d\&#39;un document (TD3.3a et TD3.3b)
     * @param ins INS du patient dont on veut connaître le statut du DMP
     * @param uniqueId 
     * @param transactionDocumentBody 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDocument(ins: string, uniqueId: string, transactionDocumentBody?: TransactionDocumentBody, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<any>;
    public updateDocument(ins: string, uniqueId: string, transactionDocumentBody?: TransactionDocumentBody, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpResponse<any>>;
    public updateDocument(ins: string, uniqueId: string, transactionDocumentBody?: TransactionDocumentBody, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json',}): Observable<HttpEvent<any>>;
    public updateDocument(ins: string, uniqueId: string, transactionDocumentBody?: TransactionDocumentBody, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json',}): Observable<any> {
        if (ins === null || ins === undefined) {
            throw new Error('Required parameter ins was null or undefined when calling updateDocument.');
        }
        if (uniqueId === null || uniqueId === undefined) {
            throw new Error('Required parameter uniqueId was null or undefined when calling updateDocument.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (ins !== undefined && ins !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ins, 'ins');
        }
        if (uniqueId !== undefined && uniqueId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>uniqueId, 'uniqueId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('apiKey', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }



        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/dmp/transaction/document`;
        return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                body: transactionDocumentBody,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
